import styled from 'styled-components';
import { darken } from 'polished';
import colors from '~/styles/colors';

export const Container = styled.div`
  margin: 1rem;
  display: flex;
  flex: 1;
  justify-content: center;
  flex-direction: column;

  header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
    h1 {
      font-size: 32;
      color: #ffff;
    }

    a {
      padding: 12px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: ${colors.primary};
      font-weight: bold;
      color: #fff;
      border: 0;
      border-radius: 4px;
      font-size: 16px;
      transition: background 0.2s;

      &:hover {
        background: ${darken(0.08, colors.primary)};
      }
      svg {
        margin-right: 10px;
      }
    }
  }
`;
export const TableContainer = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  @media (max-width: 940px) {
    justify-content: center;
  }
  flex-direction: column;

  table {
    border-spacing: 0;
    border: 1px solid black;

    thead {
      background-color: ${colors.primary};
      tr {
        :first-child {
          background: transparent;
          color: white;
          font-weight: bold;
          font-size: 1.8rem;
        }
      }
    }
    tbody {
      tr {
        :last-child {
          td {
            border-bottom: 0;
          }
        }

        font-weight: bold;
        font-size: 1.5rem;
        :nth-child(even) {
          background: #999;
          &,
          svg,
          span {
            color: white;
          }
          :hover {
            background: ${darken(0.1, '#999')};
          }
        }
        :nth-child(odd) {
          background: #fff;
          &,
          svg,
          span {
            color: black;
          }
          :hover {
            background: ${darken(0.1, '#fff')};
          }
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`;
